//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, useTheme } from '@mui/material'
import React, { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import LenderHome from './LenderHome'

import { LicenseInfo } from '@mui/x-license-pro'
import LenderPoolDetails from './LenderPoolDetails'
import LenderPortfolioPage from './LenderPortfolioPage'
import LenderTransactionPage from './LenderTransactionPage'

import LenderPoolOpenings from './LenderPoolOpenings'

import CompanyProfileLenderView from '@react/admin/CompanyProfileLenderView'
import Width1600 from '@react/components/Width1600'
import WidthLimited from '@react/components/WidthLimited'
import LytIssuerReserves from '@react/lyt/planning/LytIssuerReserves'
import ReportingPage from '@react/reporting/ReportingPage'
import { TopAppBar } from '@react/topbar/TopAppBar'
import { logOT } from '@shared/loggingShared'

// Lender routing app
LicenseInfo.setLicenseKey(
  '4aa820c74354bf0194df6f7dfa013a7fTz0xMTE4ODYsRT0xNzc3MDc1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
)

function NotFoundRedirect() {
  const location = useLocation()

  useEffect(() => {
    logOT.info('QQQQQ Redirecting from unknown route:', location.pathname)
    // Optionally display this on screen or send to analytics
  }, [location])

  return <Navigate to="/" replace />
}

export default function LenderRouting(): React.ReactElement {
  const theme = useTheme()

  return (
    <Box sx={{ backgroundColor: theme.palette.background.canvas }}>
      <TopAppBar></TopAppBar>

      <Routes>
        <Route
          path="/"
          element={
            <WidthLimited>
              <LenderHome />
            </WidthLimited>
          }
        />
        <Route
          path="/reservePlanning"
          element={
            <Width1600>
              <LytIssuerReserves />
            </Width1600>
          }
        />

        <Route
          path="/investments"
          element={
            <WidthLimited>
              <LenderPortfolioPage />
            </WidthLimited>
          }
        />
        <Route
          path="/availableVaults"
          element={
            <WidthLimited>
              <LenderPoolOpenings />
            </WidthLimited>
          }
        />
        <Route path="/transactions" element={<LenderTransactionPage />} />
        <Route path="/reporting" element={<ReportingPage />} />

        <Route path="/companyProfile" element={<CompanyProfileLenderView />} />
        <Route
          path="/pools/:poolAddr"
          element={
            <WidthLimited>
              <LenderPoolDetails />
            </WidthLimited>
          }
        />
        <Route path="*" element={<NotFoundRedirect />} />
      </Routes>
    </Box>
  )
}
